<app-alert></app-alert>
<div class="row">
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
    <div class="col-sm-12 col-md-4 align-center">
        <legend>Health and Beauty</legend>
    </div>
    <div class="col-sm-12 col-md-4">
        <hr>
    </div>
</div>

<div class="row">
    <div class="col-xs-12 padding-left-and-right text-justify text-add-line-height">
Health and beauty are so important to me that it deserves it’s own page.  About 2 years ago a 
friend directed me to watch a youTube video by Joe Dispenza that talked about how what you 
think about creates your reality.  That video was life changing for me.  
Since then I have been practicing meditation daily and reading self development books and 
watching self development videos on youTube.   All of this research and studying has helped 
me to learn more about myself and made me realize the kind of person that I want to become.  
<br><br>
Since then, I have developed a strong morning routine which I follow religiously.  I always 
start my day with meditation and gratitude and this sets the tone for the start of my day.  
I also make my bed perfectly every morning because that ensures that I accomplish at least one 
task that day perfectly.  Although a small task it sets the stage for my day and a lot of small 
accomplishments adds up.  
<br><br>
In my research, I have also learned that food has huge effect on how we think and feel.  
I have cut out meat and most dairy in my diet.  My body feels so much lighter and healthier.   
I also started having smoothies with kale and glow protein powder every morning.  In addition, 
I have super greens and beet juice in the morning.  My last meal of the day is dinner and I do 
not snack or eat anything in between meals or after dinner.  I also started including 3 day 
juice cleanses in my routine.  I typically only do this once every 3 months.  My body felt so 
amazing after and it helped me to have more control over what I eat and put into my body.  
<br><br>
All in all, what we feed our mind, body and skin is important and we become what we eat and 
think about, so make sure you are eating healthy and feeding your mind with positive thoughts.  
In addition, make sure daily that you think about all the things you are grateful for.   
Focus on yourself and not others.  Why?  Because you have no control over others but you do 
have control over yourself.  
<br><br>
Take care of yourself even when no one is around.  Every day after I do my meditation and shower, 
I always do my hair and makeup no matter if I will see anyone that day or not.  Why?  Because it 
will make you feel better.  
<br><br>
I think happiness and calmness is the key to living an abundant life.  When your happy, others 
will feel your energy and you will notice others around you will be happier.  I would like to share 
some of my favorite motivational and spiritual speakers and I have added 
links to where you can check out their content.  
<br>
<br>
<div>
    <a class=" px-2" target="_blank" href="https://www.youtube.com/channel/UCZzuauSCw9aXx-tUB-E7Tfw">
        Master Sri Arkashana
      </a>
</div>
<div>
    <a class=" px-2" target="_blank" href="https://www.jimrohn.com">
        Jim Rohn
      </a>
</div>
<div>
    <a class="px-2" target="_blank" href="https://www.youtube.com/channel/UCcYzLCs3zrQIBVHYA1sK2sw">
        Sadhguru
      </a></div>
<div>
    <a class=" px-2" target="_blank" href="https://www.youtube.com/user/drjoedispenza">
        Joe Dispenza
      </a></div>

</div>
</div>
